import Raven from "raven-js";
import config from "../config";

const init = () => {
  if (config("SENTRY_ERROR_ACCESS_APP")) {
    Raven.config(config("SENTRY_ERROR_ACCESS_APP"), {
      whitelistUrls: [config("TICKETING_URL")]
    }).install();
  }
};

const track = err => {
  try {
    if (config("SENTRY_ERROR_ACCESS_APP")) {
      Raven.captureException(err);
      return;
    }
    console.error(err);
  } catch (err) {}
};

export default { init, track };



// WEBPACK FOOTER //
// ./utils/ErrorTracking.js